<template>
  <div>
    <p>PROFILE PAGE</p>
    <v-btn @click.prevent="onLogout()">Logout</v-btn>
    <br/>
  </div>
</template>

<script>
import {
    mapGetters
  } from 'vuex'

export default {
name : 'ProfilePage',
  methods : {
    onLogout ()  {
      this.$store.dispatch('resetUser')
      this.$router.push('/')
    }
  },
  mounted()  {

    $("#testbtn").html('test2')

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/user/ProfilePage.vue